import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchProductsGlobal } from "../services";

export const fetchProductsGlobalData = createAsyncThunk(
  "productsGlobal/fetchProductsGlobalData",
  async (countryId, { rejectWithValue }) => {
    try {
      const data = await fetchProductsGlobal(countryId);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const productGlobalSlice = createSlice({
  name: "productsGlobal",
  initialState: {
    data: [],
    loading: false,
    error: null,
    product: null
  },
  reducers: {
    // Puedes agregar más acciones sincronas si es necesario
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductsGlobalData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductsGlobalData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchProductsGlobalData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default productGlobalSlice.reducer;
